import { render } from "./buildingtypesComponent.vue?vue&type=template&id=57e7ffa5"
import script from "./buildingtypesComponent.vue?vue&type=script&lang=js"
export * from "./buildingtypesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__